import { getPropertiesFromPathname } from './getPropertiesFromPathname';

/**
 * Retrieves app properties.
 */
export const getProperties = getPropertiesFromPathname;
